import { render, staticRenderFns } from "./GroupClient.vue?vue&type=template&id=3a7876f8"
import script from "./GroupClient.vue?vue&type=script&lang=js"
export * from "./GroupClient.vue?vue&type=script&lang=js"
import style0 from "./GroupClient.vue?vue&type=style&index=0&id=3a7876f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports